module.exports = __webpack_public_path__ + "img/main_title_2026.ae021ffa.svg";